module.exports = __webpack_public_path__ + "static/media/newcandidate.5ed2359a.svg";